export const evaluation = [
    {
        path: '/evaluation-v4',
        component: () => import("@/modules/evaluation/EvaluationPage.vue")
    },
    {
        path: '/evaluation/category-settings',
        component: () => import("@/modules/evaluation/EvaluationCategorySettingsPage.vue")
    }
]